jQuery(($) => {
    function init() {
        const $form = $('.woocommerce-cart-form');
        const $updateBtn = $form.find('button[name="update_cart"]');
        const $qtyFields = $form.find('.qty')

        $qtyFields.blur(function () {
            $updateBtn.click();
        })
    }

    $(document.body).on('updated_wc_div', function () {
        init()
    });

    // this event is triggered when a product is added to the cart
    $(document.body).on('added_to_cart', function() {
        $('#site-header-cart').addClass('active');
        setTimeout(() => {
            $('#site-header-cart').removeClass('active');
        }, 5000);
    });


    init();
});